function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 18">
      <path fill="currentColor" d="M18 6V0H0v18h18v-6l8 6V0ZM6 14V4l7 5Z" />
    </svg>
  );
}

export default Icon;
